import FIELDS_EMPLOYEE from '@/helpers/field-definitions.json';
import { Button } from '@/platform/ui';
import { PlusIcon } from '@heroicons/react/24/outline';
import { useMemo } from 'react';
import Rule from './Rule';

const RulesList = ({ data, onChange }) => {
    const fieldsOptions = useMemo(
        () =>
            Object.keys(FIELDS_EMPLOYEE['LKV scan']).map(field => ({
                id: field,
                name: FIELDS_EMPLOYEE['LKV scan'][field].label,
            })),
        []
    );

    const addRule = () => {
        onChange('rules', [
            ...(data?.rules || []),
            {
                id: Date.now(),
                type: 'field',
                field: '',
                operator: '',
                value: '',
                connector: 'AND',
            },
        ]);
    };

    const handleRuleChange = (id, field, value) => {
        onChange(
            'rules',
            data?.rules?.map(rule => {
                if (rule.id === id) {
                    return {
                        ...rule,
                        [field]: value,
                    };
                }

                return rule;
            })
        );
    };

    const handleRuleDelete = id => {
        onChange(
            'rules',
            data?.rules?.filter(rule => rule?.id !== id)
        );
    };

    return (
        <>
            <div className='my-4 flex justify-end'>
                <Button type='button' onClick={addRule}>
                    <PlusIcon className='size-5' />
                    Regel toevogen
                </Button>
            </div>

            {data?.rules?.map(rule => (
                <Rule
                    key={rule.id}
                    rule={rule}
                    onChange={handleRuleChange}
                    onDelete={handleRuleDelete}
                    fieldsOptions={fieldsOptions}
                />
            ))}
        </>
    );
};

export default RulesList;
